<template>
  <div class="maskBox" @click="close()">
    <div class="confirmWithdraw" @click.stop>
      <div class="title">{{$t('lang.cashWheel.pleaseContinue')}}</div>
      <div class="btnBox" @click.stop="close()">
        <div class="Btn">{{$t('lang.cashWheel.go')}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'modal-pleaseContinue',
  data () {
    return {}
  },
  methods: {
    close () {
      this.$emit('closeModalPleaseContinue')
    }
  }
}
</script>

<style lang="less" scoped>
.maskBox{
  height: 100vh;
  width: 100%;
  position: fixed;
  background-color: rgba(0,0,0,0.8);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
}
@keyframes expandBox {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
.confirmWithdraw{
  width: 82.23vw;
  height: 66.94vw;
  color: #D9D9D9;
  font-weight: 700;
  font-size: 5.27vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 15vw;
  animation: expandBox 0.2s ease-in-out forwards;
  border: 1px solid #888888;
  border-right: 2px solid #888888;
  border-left: 2px solid #888888;
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(8px);
  border-radius: 1.243vw;
  .title{
    width: 71.85vw;
    text-align: center;
  }
  .tip{
    color: rgb(109,109,109);
    font-size: 4.44vw;
    font-weight: 500;
    position: relative;
    top: -3.5vw;
  }
  .btnBox{
    display: flex;
    flex-direction: column;
    gap: 3vw;
    .Btn{
      width: 65.913vw;
      height: 10.833vw;
      color: #000000;
      font-size: 4.44vw;
      font-weight: 700;
      display: flex;
      align-items: center;
      justify-content: center;
      background: linear-gradient(90deg, #01B7D3 0%, #13C498 100%), #F1DAB0;
      border-radius: 1.388vw;
    }
    .BtnBox{
      width: 65.913vw;
      height: 10.833vw;
      background-color: #F1DAB0;
      border-radius: 1.5vw;
      color: #F1DAB0;
      font-size: 4.44vw;
      font-weight: 700;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0.3vw;
      .Btn2{
        height: 100%;
        width: 100%;
        background-color: #181818;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 1.5vw;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/cashWheel/modal-pleaseContinue.vue